module.exports = __webpack_public_path__ + "img/image-style-05.5d39f29e.svg";